import { observable, action } from 'mobx';

import { api } from '../services';

class PagedCollectionStore {
  @observable _handles = {};

  @action
  init(initData) {
    const defaultData = {
      source: [],
      sourceCount: 0,
      framed: [],
      count: 0,
      current: 1,
      itemsPerPage: 10,
      limit: undefined,
      loading: false,
      pagination: false,
      availableInTabs: false
    };
    const data = { ...defaultData, ...initData };
    const { key } = data;
    // this._handles = { ...this._handles, [key]: { ...data, key: undefined } };
    this._handles = { ...this._handles, [key]: { ...data } };
    this.processCollection(data);
  }

  processCollection(data) {
    const { key } = data;
    if (data.source && data.source.hasOwnProperty('api')) {
      // data.source.api[0] // nome api
      // data.source.api[1] // primo parametro (id)

      this._handles[key].loading = true;
      // api('method', carId, page, size, sort, order)
      api(data.source.api[0], data.source.api[1], data.current, data.itemsPerPage)
        .then(response => {
          const sourceCount = response.count;
          const pagination = {
            total: response.count,
            // current: data.current,
            current: 1,
            defaultCurrent: 1,
            hideOnSinglePage: true,
            pageSize: data.itemsPerPage,
            simple: true,
            size: 'small',
            onChange: (page, pageSize) => this.onCollectionPageChange(key, page, pageSize)
          };
          this._handles[key].loading = false;
          this._handles[key].count = response.count;
          this._handles[key].sourceCount = sourceCount;
          this._handles[key].framed = response.rows;
          this._handles[key].pagination = pagination;
        })
        .catch(err => {
          this._handles[key].count = 0;
          this._handles[key].sourceCount = 0;
          this._handles[key].framed = [];
        })
        .then(err => {
          this._handles[key].loading = false;
        });
    } else {
      const sourceCount = data.source.length;
      if (data.limit !== undefined) {
        this._handles[key].source = data.source.slice(0, data.limit);
      }
      const pagination = {
        total: data.source.length,
        current: data.current,
        defaultCurrent: 1,
        hideOnSinglePage: true,
        pageSize: data.itemsPerPage,
        simple: true,
        size: 'small',
        onChange: (page, pageSize) => this.onCollectionPageChange(key, page, pageSize)
      };
      this._handles[key].count = data.source.length;
      this._handles[key].sourceCount = sourceCount;
      this._handles[key].framed = data.source.slice(0, data.itemsPerPage);
      this._handles[key].pagination = pagination;
    }
  }

  onCollectionPageChange = (key, page, pageSize) => {
    let { pagination } = this._handles[key];
    if (this._handles[key].source && this._handles[key].source.hasOwnProperty('api')) {
      this._handles[key].loading = true;
      api(this._handles[key].source.api[0], this._handles[key].source.api[1], page, pageSize)
        .then(response => {
          this._handles[key].loading = false;
          this._handles[key].current = page;
          this._handles[key].pagination = { ...this._handles[key].pagination, current: page };
          this._handles[key].framed = response.rows;
          this._handles[key].count = response.count;
        })
        .catch(err => {
          this._handles[key].count = 0;
          this._handles[key].sourceCount = 0;
          this._handles[key].framed = [];
        })
        .then(err => {
          this._handles[key].loading = false;
        });
    } else {
      const lower = pageSize * (page - 1);
      const upper = lower + pageSize;
      this._handles[key].current = page;
      this._handles[key].pagination = { ...pagination, current: page };
      this._handles[key].framed = this._handles[key].source.slice(lower, upper);
    }
  };

  get(namespace) {
    // const grouped = Object.keys(this._handles)
    //   // .filter( key => predicate(this._handles[key]) )
    //   .filter(key => key === namespace || key.startsWith(`${namespace}.`))
    //   .reduce((res, key) => Object.assign(res, { [key]: this._handles[key] }), {});
    // return grouped;
    // // return this._handles;
    return this._handles && this._handles.hasOwnProperty(namespace) ? this._handles[namespace] : undefined;
  }

  getAny(namespace) {
    const grouped = Object.keys(this._handles)
      .filter(key => key === namespace || key.startsWith(`${namespace}.`))
      .reduce((res, key) => Object.assign(res, { [key]: this._handles[key] }), {});
    return grouped;
  }

  onCollectionTableChange = (key, pagination, filters, sorter) => {
    const page = this._handles[key].current;
    const pageSize = this._handles[key].itemsPerPage;

    let [sort, order] = [undefined, undefined];
    if (Object.keys(sorter).length !== 0 && sorter.constructor === Object) {
      sort = sorter.field;
      order = sorter.order === 'descend' ? 'DESC' : 'ASC';
    }

    if (this._handles[key].source && this._handles[key].source.hasOwnProperty('api')) {
      this._handles[key].loading = true;
      api(this._handles[key].source.api[0], this._handles[key].source.api[1], page, pageSize, sort, order)
        .then(response => {
          this._handles[key].loading = false;
          this._handles[key].current = page;
          this._handles[key].pagination = { ...this._handles[key].pagination, current: page };
          this._handles[key].framed = response.rows;
          this._handles[key].count = response.count;
        })
        .catch(err => {
          this._handles[key].count = 0;
          this._handles[key].sourceCount = 0;
          this._handles[key].framed = [];
        })
        .then(err => {
          this._handles[key].loading = false;
        });
    } else {
      let sortedSource = this._handles[key].source;
      if (order === 'DESC') {
        sortedSource = sortedSource.slice().sort((a, b) => (a[sort] > b[sort] ? -1 : b[sort] > a[sort] ? 1 : 0));
      } else if (order === 'ASC') {
        sortedSource = sortedSource.slice().sort((a, b) => (a[sort] > b[sort] ? 1 : b[sort] > a[sort] ? -1 : 0));
      }
      const lower = this._handles[key].pagination.pageSize * (this._handles[key].current - 1);
      const upper = lower + this._handles[key].pagination.pageSize;
      this._handles[key].framed = sortedSource.slice(lower, upper);
    }
  };
}

export default new PagedCollectionStore();



// WEBPACK FOOTER //
// ./src/stores/pagedCollectionStore.js